import { addDays } from 'date-fns';
import { useRecoilValue } from 'recoil';

import { Heading } from '@/components/heading';
import { FlightServiceList } from '@/components/modules/flight-service/list';
import { OptionHeader } from '@/components/modules/option/header';
import { MODE_AIR } from '@/lib/constants';
import { getLocationPreferredIdentifiers } from '@/lib/models/location/get-location-preferred-identifiers';
import { OptionModel } from '@/lib/models/option/types';
import { locationsState } from '@/state/locations';
import { getToday } from '@/utils/format/date-time';

export interface FlightServiceSummaryProps {
  option: OptionModel;
  originId: string;
  destinationId: string;
  carrierIds: string[];
  transferLocationIds: string[];
  today?: Date;
}

const FlightServiceSummary = ({
  option,
  originId,
  destinationId,
  transferLocationIds,
  carrierIds,
  today = getToday(),
}: FlightServiceSummaryProps) => {
  const mode = MODE_AIR;
  const locations = useRecoilValue(locationsState);
  const transferIdentifiers = getLocationPreferredIdentifiers({ locationIds: transferLocationIds, locations });

  return (
    <>
      <OptionHeader option={option} mode={mode} originId={originId} destinationId={destinationId} />
      <div className="mt-2 border-t border-grey-200 bg-white">
        <div className="mx-8 mb-2 mt-6">
          <Heading variant="h2" className="mb-0 !text-md leading-tight">
            Scheduled services
          </Heading>
        </div>
        <FlightServiceList
          originId={originId}
          destinationId={destinationId}
          routes={[
            {
              via: transferIdentifiers.map((location) => `${location.type} ${location.value}`),
              carriers: carrierIds || [],
            },
          ]}
          date={addDays(today, 2)}
        />
      </div>
    </>
  );
};

export { FlightServiceSummary };
